import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ComunicationNavtopBranchofficeService {

  private dataSubject = new Subject<any>();
  data$ = this.dataSubject.asObservable();  
  reloadData(data: any) {
    this.dataSubject.next(data);
  }
}
